<template lang="html">

  <section class="table">
    <h1>table Component</h1>
  </section>

</template>

<script lang="js">
export default {
  name: 'table',
  props: [],
  mounted() {
  },
  data() {
    return {
    };
  },
  methods: {
  },
  computed: {
  },
};
</script>

<style scoped lang="scss">
.table {

}
</style>



// WEBPACK FOOTER //
// src/components/table.vue